import { render, staticRenderFns } from "./IconTextEditor.vue?vue&type=template&id=0c9184ce"
import script from "./IconTextEditor.vue?vue&type=script&lang=js"
export * from "./IconTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports